import { createAsyncThunk, AsyncThunkPayloadCreator, AsyncThunk, createReducer, createAction } from '@reduxjs/toolkit';

// eslint-disable-next-line
interface ThunkAPIConfig {}

// eslint-disable-next-line
export const createAppAsyncThunk = <Returned, ThunkArg = any>(
  type: string,
  thunk: AsyncThunkPayloadCreator<Returned, ThunkArg>, // <-- very unsure of this - have tried many things here
): AsyncThunk<Returned, ThunkArg, ThunkAPIConfig> => {
  return createAsyncThunk<Returned, ThunkArg, ThunkAPIConfig>(type, async (arg, thunkAPI) => {
    try {
      return await thunk(arg, thunkAPI);
      // eslint-disable-next-line
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  });
};

const startRequest = createAction('startRequest');
const endRequest = createAction('endRequest');
const setError = createAction('setError');
const clearError = createAction('clearError');

const initialState = {
  loading: false,
  hasError: false,
};
export const loadersReducer = createReducer(initialState, builder => {
  builder.addCase(startRequest, state => {
    state.loading = true;
  });
  builder.addCase(endRequest, state => {
    state.loading = false;
  });
  builder.addCase(setError, state => {
    state.hasError = true;
  });
  builder.addCase(clearError, state => {
    state.hasError = false;
  });
});

// eslint-disable-next-line
export const createAppPreAsyncThunk = <Returned, ThunkArg = any>(
  type: string,
  thunk: AsyncThunkPayloadCreator<Returned, ThunkArg>, // <-- very unsure of this - have tried many things here
): AsyncThunk<Returned, ThunkArg, ThunkAPIConfig> => {
  return createAsyncThunk<Returned, ThunkArg, ThunkAPIConfig>(type, async (arg, thunkAPI) => {
    try {
      thunkAPI.dispatch(startRequest());
      return await thunk(arg, thunkAPI);
      // eslint-disable-next-line
    } catch (error: any) {
      thunkAPI.dispatch(setError());
      return thunkAPI.rejectWithValue(error.response.data);
    } finally {
      thunkAPI.dispatch(endRequest());
      thunkAPI.dispatch(clearError());
    }
  });
};
